import { Component, NO_ERRORS_SCHEMA } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { FieldType, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'app-form-yesno',
  styleUrls: ['form-yesno.component.scss'],
  template: `<mat-checkbox
      [ariaRoleDescription]="'checkbox'"
      [ariaChecked]="formControl.value"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [required]="props.required"
      (change)="change($event, to, field)"
      ><span tabindex="0" [innerHTML]="props.label"></span
    ></mat-checkbox>
    @if (formControl.hasError('regRequired')) {
      <mat-error>
        This field is needed for suitability review. You can opt out below if
        the applicant refuses to provide the information.
      </mat-error>
    } `,
  imports: [
    MatCheckboxModule,
    MatInputModule,
    ReactiveFormsModule,
    FormlyModule,
  ],
})
export class FormlyYesNoComponent extends FieldType {
  change(ev, to, field) {
    field.model[field.key] = ev.checked;
  }
}
